import { render } from "./SinglePlaylist.vue?vue&type=template&id=83cf6d10"
import script from "./SinglePlaylist.vue?vue&type=script&lang=js"
export * from "./SinglePlaylist.vue?vue&type=script&lang=js"

import "./SinglePlaylist.vue?vue&type=style&index=0&id=83cf6d10&lang=css"

import exportComponent from "/Users/peter/projects/BhubCollege/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__